<template>
  <div>
    <div class="">
      <div class="font-bold text-lg">รายละเอียดการตรวจรับ</div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 mt-4">
      <!-- ชื่อผู้ขาย/ผู้รับจ้าง -->
      <div>
        <label class="form-label font-bold">ชื่อผู้ขาย/ผู้รับจ้าง:</label>
        <div>{{ vendor.code }} - {{ vendor.name }}</div>
      </div>
      <!-- เลขที่ใบขอซื้อ -->
      <div class="flex flex-row lg:flex-col justify-between mt-2 lg:mt-0">
        <label class="form-label font-bold">เลขที่ใบขอซื้อ:</label>
        <div>{{ prDocNoFull }}</div>
      </div>
      <!-- เลขที่ใบสั่งซื้อ/สัญญา -->
      <div class="flex flex-row lg:flex-col justify-between">
        <label class="form-label font-bold">เลขที่ใบสั่งซื้อ/สัญญา:</label>
        <div>{{ poDocNoFull }}</div>
      </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 lg:mt-4">
      <!-- ใบส่งของ เลขที่ -->
      <div class="flex flex-row lg:flex-col justify-between">
        <label class="form-label font-bold">ใบส่งของ เลขที่: </label>
        <div>{{ invoice.no }}</div>
        <!-- <span class="text-xs text-gray-500"
          >* ใบส่งของ/ใบแจ้งหนี้/ใบกำกับภาษี</span
        > -->
      </div>
      <!-- รับสินค้า ณ วันที่ -->
      <div class="flex flex-row lg:flex-col justify-between">
        <label class="form-label font-bold">รับสินค้า ณ วันที่:</label>
        <div>{{ reqDate }}</div>
        <!-- <span class="text-xs text-gray-500"
          >* รับสินค้า/รับ Inv. /กรรมการตรวจรับ ณ วันที่</span
        > -->
      </div>
      <!-- วันที่ใบแจ้งหนี้ -->
      <div class="flex flex-row lg:flex-col justify-between">
        <label class="form-label font-bold">วันที่ใบแจ้งหนี้:</label>
        <div>{{ invoice.date }}</div>
      </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 lg:mt-4">
      <!-- GL Date -->
      <GLDate
        url="procurement/gr/updateGldate"
        :id="id"
        :glDate="glDate"
        :isPermissionVat="isPermissionVat"
        :isApprove="isApprove"
        :isClaim="isClaim"
      />
      <!-- งวดการตรวจรับ -->
      <div class="flex flex-row lg:flex-col justify-between">
        <label class="form-label font-bold">งวดการตรวจรับ:</label>
        <div class="form-check gap-4">
          <div>
            {{ instalment.typeText }}
          </div>
        </div>
      </div>
      <!-- งวดที่ -->
      <div class="flex flex-row lg:flex-col justify-between">
        <label class="form-label font-bold">งวดที่:</label>
        <div>{{ instalment.no }}</div>
      </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 lg:mt-4">
      <!-- อืน ๆ -->
      <div class="col-span-2">
        <label class="form-label font-bold">รายละเอียด :</label>
        <div
          class="overflow-x-auto"
          v-html="reqDetail ? reqDetail.replaceAll('\n', '<br />') : ''"
        ></div>
      </div>
      <!-- ไฟล์แนบ -->
      <div class="col-span-1 mt-2 lg:mt-0">
        <label class="form-label font-bold">ไฟล์แนบ:</label>
        <AttachFilePreview :data="fileAttachArray" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs, ref } from 'vue'
import AttachFilePreview from '@/components/attach-file/Preview.vue'
import GLDate from '@/components/GLDate.vue'

export default defineComponent({
  name: 'detail-receive',
  components: {
    AttachFilePreview,
    GLDate
  },
  props: {
    id: Number,
    vendor: {
      type: Object,
      default: () => {
        return {
          code: '',
          name: ''
        }
      }
    },
    prDocNoFull: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    poDocNoFull: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    invoice: {
      type: Object,
      default: () => {
        return {
          no: '',
          date: ''
        }
      }
    },
    reqDate: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    reqDetail: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    instalment: {
      type: Object,
      default: () => {
        return {
          no: '',
          typeText: ''
        }
      }
    },
    glDate: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    fileAttachArray: {
      type: Array,
      default: () => []
    },
    isPermissionVat: Boolean,
    isApprove: Boolean,
    isClaim: Boolean
  },
  setup(props) {
    const date = ref(props.glDate)
    return {
      ...toRefs(props),
      date
    }
  }
})
</script>
